export default __webpack_public_path__ + "static/media/paper.c643fd1b.svg";